// extracted by mini-css-extract-plugin
export var attribution = "_aq-4";
export var authorName = "_aq-5";
export var quote = "_aq-3";
export var testimonial = "_aq-2";
export var trustedBy = "_aq-0";
export var trustedByLabel = "_aq-1";